import React from "react";
import {
  Box,
  Container,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
  Link as MuiLink,
} from "@mui/material";
import { BorderedButton, GradientBorderBox } from "../../../../Components";
import LeftSide from "./LeftSide";
import { spliter } from "../../../../Utils/Spliter";

export default function TopProducts({ banners }) {
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:600px)");
  const slides = banners?.filter((slide) => slide?.position === "first");

  return (
    <Container maxWidth="xxl" sx={{ position: "relative", py: "1rem" }}>
      <Stack
        direction="row"
        sx={{
          width: "100%",
          // height: { xs: "400px", sm: "500px", md: "600px", lg: "700px" },
          aspectRatio: "2/1",
          gap: "1.5rem",
        }}
      >
        {/* Main Right Side Banner */}
        <Stack
          component={MuiLink}
          href={slides?.[0]?.back_link}
          sx={{
            // maxWidth: "600px",
            mx: "auto",
            width: { xs: "100%", lg: "35%" },
            height: "100%",
            position: "relative",
            // overflow: "hidden",
            cursor: "pointer",
            textDecoration: "none",
            color: "white",
            zIndex: 100,
            "&:hover .hoveredImage": {
              filter: "blur(8px) brightness(0.5)",
              transform: "scale(1.05)",
            },
            "&:hover .hoveredContent": {
              opacity: 1,
              transform: "translateY(0)",
            },
          }}
        >
          <Box
            className="hoveredImage"
            sx={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
            }}
          >
            <img
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              src={
                isMobile
                  ? import.meta.env?.VITE_URL +
                    slides?.[0]?.image_mobile?.file_name
                  : import.meta.env?.VITE_URL +
                    slides?.[0]?.image_desktop?.file_name
              }
              alt={slides?.[0]?.image_desktop?.alt}
              title={slides?.[0]?.image_desktop?.title}
            />
          </Box>

          {/* Hover Overlay Content */}
          <Stack
            className="hoveredContent"
            sx={{
              position: "absolute",
              inset: 0,
              p: "2rem",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              gap: "1.5rem",
              opacity: 0,
              transform: "translateY(20px)",
              transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
              zIndex: 10,
            }}
          >
            <Typography
              sx={{ fontSize: { xs: "0.9rem", md: "1.1rem" }, lineHeight: 1.8 }}
            >
              {spliter({
                mobileLimit: 50,
                limit: 280,
                text: slides?.[0]?.desc,
              })}
            </Typography>
            <BorderedButton
              sx={{
                minWidth: "50%",
                fontSize: { xs: "0.75rem", md: "0.85rem" },
              }}
            >
              مشاهده موبایل های اپل
            </BorderedButton>
          </Stack>

          <GradientBorderBox
            bgGrad={`linear-gradient(
              -45deg,
              ${theme.palette.background.white} -70%,
              ${theme.palette.background.default} 30%,
              ${theme.palette.background.gray} 200%
            )`}
            radius={{ xs: "1rem", xl: "1.5rem" }}
          />
        </Stack>

        {/* Left Side Grid Template */}
        <Stack
          sx={{
            width: "65%",
            height: "100%",
             display: { xs: "none", lg: "flex" },
          }}
        >
          <LeftSide slides={slides} />
        </Stack>
      </Stack>

      {/* Decorative Circles */}
      <Box
        sx={{
          position: "absolute",
          top: "80%",
          left: "110%",
          transform: "translate(-70% , -45%)",
          zIndex: -10,
          width: { xs: "200px", sm: "300px", lg: "500px" },
          height: { xs: "200px", sm: "300px", lg: "500px" },
        }}
      >
        <img
          style={{ width: "100%", height: "100%" }}
          src="/Media/Circles/circle.svg"
          alt="circle images"
        />
      </Box>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "30%",
          transform: "translate(-50% , -45%)",
          zIndex: -10,
          width: { xs: "150px", md: "300px" },
          height: { xs: "150px", md: "300px" },
        }}
      >
        <img
          style={{ width: "100%", height: "100%" }}
          src="/Media/Circles/circle.svg"
          alt="circle images"
        />
      </Box>
    </Container>
  );
}
